import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'app-checkbox-with-label',
  imports: [],
  templateUrl: './checkbox-with-label.component.html',
  styleUrl: './checkbox-with-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxWithLabelComponent {
  public readonly type = input<'short' | 'long'>('long');
  public readonly inputId = input<string>();

  protected readonly isShort = computed(() => this.type() === 'short');
  protected readonly isLong = computed(() => this.type() === 'long');
}
